module.exports = __webpack_public_path__ + "static/media/video02.6182f82.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/video02.mp4
// module id = /apU
// module chunks = 18